// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-side-datatable .ag-cell {
    font-family: 'Poppins', sans-serif !important;
  }
  
  .client-side-datatable .ag-header-cell{
    font-family: 'Poppins', sans-serif !important;
  }
  
  .client-side-datatable .ag-header-cell-text{
    padding-left: 10px;
    
  }`, "",{"version":3,"sources":["webpack://./src/components/agclient.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,kBAAkB;;EAEpB","sourcesContent":[".client-side-datatable .ag-cell {\n    font-family: 'Poppins', sans-serif !important;\n  }\n  \n  .client-side-datatable .ag-header-cell{\n    font-family: 'Poppins', sans-serif !important;\n  }\n  \n  .client-side-datatable .ag-header-cell-text{\n    padding-left: 10px;\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
